import { useMixpanel } from '@/composables/useMixpanel'
import type { Mixpanel } from '@/plugins/mixpanel'

/**
 * Runs a callback with the Mixpanel instance when the SDK is loaded.
 * Failures (ad blockers, local dev) are swallowed so auth and navigation never break.
 * Logs at debug level in dev only.
 */
export const withMixpanel = (callback: (mixpanel: Mixpanel) => void): void => {
  try {
    const mixpanel = useMixpanel()

    if (mixpanel) {
      callback(mixpanel)
    }
  } catch (error) {
    if (import.meta.env.DEV) {
      console.debug('Mixpanel call failed', error)
    }
  }
}
